import React, { useState } from "react";
import { Button, Image, Modal } from "legion-ui";

const ModalWithImage = () => {
  const [isActiveModal2, setIsActiveModal2] = useState(false);

  const modalFooter2 = () => {
    return (
      <div style={{ display: "flex", justifyContent: "right" }}>
        <Button onClick={toggleCustomModal2} css={{ marginRight: "12px" }}>
          Okay, got it!
        </Button>
      </div>
    );
  };
  const toggleCustomModal2 = () => setIsActiveModal2(!isActiveModal2);
  const closeModal2 = () => {
    if (isActiveModal2) {
      toggleCustomModal2();
    }
  };

  return (
    <React.Fragment>
      <Button onClick={toggleCustomModal2} css={{ marginBottom: "12px" }}>
        Modal with Image
      </Button>
      <Modal
        isActive={isActiveModal2}
        modalId="legion-modal-2"
        onClose={closeModal2}
        style={{ padding: 0 }}
        footer={modalFooter2()}
      >
        <Image src="https://www.treehugger.com/thmb/8he5rIw5n2ukJ44XXOHK7L-6PIc=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/__opt__aboutcom__coeus__resources__content_migration__mnn__images__2017__05__lady-bug-on-leaf-e3cd36cdc3024129b61926ddf6ef386e.jpg" />
        <div style={{ padding: "18px" }}>
          <h3>Modal with Images</h3>
          <p>
            This is the modal with custom content, you can pass images, text,
            and customize modal padding.
          </p>
          <p>
            By removing header and iconName modal properties, the close modal
            icon will automatically removed.
          </p>

          <p>Have a nice try with Legion-ui Modal!</p>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ModalWithImage;
